import HeaderNotifications from './HeaderNotifications'

export default HeaderNotifications
